import { Route } from '@angular/router';
import { DefaultLayoutComponent } from '@coworkrz/shared/layout';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: '/check-in',
    pathMatch: 'full',
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      {
        path: 'check-in',
        loadComponent: () =>
          import('@coworkrz/clients/feature-check-in').then(
            (c) => c.ClientsCheckInComponent
          ),
      },
    ],
  },
];
